import Button from 'blocks.simple/button/button'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import EditText from 'blocks.simple/editText/editText'
import translate from 'core/translate'
import React, { useState } from 'react'
import styles from './displays__uploadLogs.jcss'
import { api } from 'core/api/ConnectionManager'
import { toast } from 'react-toastify'
import DisplaysUploadLogNotification from '../__uploadLogNotification/displays__uploadLogNotification'
import { colors } from '../../../theme'
import { RootStateOrAny, useSelector } from 'react-redux'
import helpers from '../../../core/helpers'

interface Props {
    selectedInfo: any | any[]
    onClose: () => void
}

const LOG_TYPE = [
    {
        id: 0,
        value: true,
        name: translate('actual_logs'),
    },
    {
        id: 1,
        value: false,
        name: translate('full_logs'),
    },
]

const DisplaysUploadLogs = ({ selectedInfo, onClose }: Props) => {
    const [logType, setLogType] = useState<any>(0)
    const company: any = useSelector<RootStateOrAny>((state) => state.user.company)

    console.log(company.logsStorageDays)

    const displayName = Array.isArray(selectedInfo)
        ? selectedInfo
              .slice(-2)
              .map((item) => item.name)
              .join(', ')
              .concat('...')
        : selectedInfo?.name

    const handleUploadLog = async () => {
        const list = Array.isArray(selectedInfo) ? selectedInfo : [selectedInfo]
        const ids = list.filter((item) => item.type === 'digitalSignage').map((item) => item.id)
        const groupIds = list.filter((item) => item.type === 'group').map((item) => item.id)

        api.send(
            'createUploadLogTask',
            {
                ids,
                groupIds,
                actual: LOG_TYPE.find((type) => type.id === logType)?.value,
            },
            {
                showEmitError: true,
            }
        ).then((res: any) => {
            toast.info(<DisplaysUploadLogNotification />, {
                hideProgressBar: true,
                position: 'bottom-left',
            })
            onClose()
        })
    }

    const getLogStorageDays = () => {
        const value = company.logsStorageDays || 7

        return (
            value +
            ' ' +
            translate(helpers.getLabelByNumber(value, [translate('dayN1'), translate('dayN2'), translate('dayN3')]))
        )
    }
    return (
        <div className={styles.modal}>
            <div className={styles.modalInner}>
                <div className={styles.title}>{translate('uploadLogsTitle')}</div>
                {!selectedInfo.length && (
                    <div>
                        <EditText
                            value={displayName}
                            disabled={true}
                            label={translate(selectedInfo.type === 'group' ? 'groupName' : 'displayName')}
                        />
                    </div>
                )}
                <div className={styles.hint}>
                    {`${translate(
                        selectedInfo.length ? 'logLifespanList_1' : 'logLifespanQ'
                    )} ${getLogStorageDays()} ${translate('logLifespanList_2')}`}
                </div>
                <div>{translate('uploadLogParameters')}</div>
                <div className={styles.subLabel}>{translate('chooseOnlyOneParameter')}</div>
                <Dropdown
                    options={LOG_TYPE}
                    onChange={(selected: any) => {
                        setLogType(selected.id)
                    }}
                    labelField="name"
                    valueField="id"
                    value={logType}
                />
                <div className={styles.subLabel}>{translate('willBeReadyToday')}</div>
                <div className={styles.subLabel} style={{ color: colors.errorSaturated }}>
                    {translate('displayLogWarning')}
                </div>
                <div className={styles.buttons}>
                    <Button onClick={onClose}>{translate('cancel')}</Button>
                    <Button mod="fill" onClick={handleUploadLog}>
                        {translate('upload')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DisplaysUploadLogs
